import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { GoogleApiIntegrationService } from '../google-api-integration.service';
import moment from 'moment';

@Component({
  selector: 'fv-funeral',
  templateUrl: './fv-funeral.component.html',
  styleUrls: ['./fv-funeral.component.css']
})
export class FvFuneralComponent implements OnInit {
  API_URL = "http://insurecover.co.za/luhambo-leads-management/funeral-submitter.php";
  OFFER_ID: string = "385";
  AFF_ID: string = "18897";
  S_ID: string = "18897";
  AFFILIATE_SHORT_CODE: string = "JMAFFSite10777";
  LEAD_SOURCE: string = "JMSMS";
  CHANNEL: string = "SMS";
  CAMP_ID: string = "FUNERAL-COVER";

  success: boolean = false
  budgetInsuranceForm: FormGroup;
  errorCount: number;
  agentData: any;
  productData: any;
  validationMessages: any;
  formStatus: any = {
    formErrors: {},
    submitClicked: false
  };

  constructor(private formBuilder: FormBuilder, private googleApiIntegrationService: GoogleApiIntegrationService) {
    this.agentData = {
      name: 'agentName',
      label: 'Agent Name:',
      options: [],
      placeholder: 'Select Name'
    };
  }

  ngOnInit() {
    this.createForm();
    this.budgetInsuranceForm.get('product').disable();
    this.budgetInsuranceForm.get('tnc').disable();

    this.googleApiIntegrationService.readFVNames();
    this.googleApiIntegrationService.names.subscribe((names) => {
      let namesArray = JSON.parse(names);
      namesArray.map((nameArray, index) => {
        this.agentData.options[index] = {name: 'agent-' + index, label: nameArray[0]};
      });
    });
  }

  createForm() {
    this.budgetInsuranceForm = this.formBuilder.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      tnc: [true, Validators.required],
      agentName: '',
      product: ['FUNERAL-COVER'],
      dob: ['', Validators.required],
      id: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      email: ['', [Validators.email, Validators.required]]
    });

    this.validationMessages = {
      name: {
        'required': 'Please enter a valid name'
      },
      surname: {
        'required': 'Please enter a valid surnname'
      },
      telephone: {
        'required': 'Please enter a valid number',
        'maxlength': 'Please enter a number not greater than 10 charaters',
        'minlength': 'Please enter a number not less than 10 charaters'
      },
      tnc: {
        'required': 'Please check if the customer has accepted the terms & conditions'
      },
      dob: {
        'required': 'Please select a valid date'
      },
      id: {
        'required': 'Please select enter a ID number',
        'maxlength': 'Please enter an ID number not greater than 13 charaters',
        'minlength': 'Please enter an ID number not less than 13 charaters'
      },
      email: {
        'required': 'Please enter a valid email address',
        'email': 'Please enter a valid email address'
      },
    }

    this.formStatus['formErrors'] = {
      name: '',
      surname: '',
      telephone: '',
      tnc: '',
      product: '',
      dob: '',
      id: '',
      email: ''
    }

    this.budgetInsuranceForm.valueChanges.subscribe((data) => {
      this.formIsValid();
    })
  }

  formIsValid() {
    if (!this.budgetInsuranceForm) {
      return;
    }

    const form = this.budgetInsuranceForm;
    this.errorCount = 0;

    // tslint:disable-next-line:forin
    for (const field in this.formStatus['formErrors']) {
      // clear previous error message (if any)
      this.formStatus['formErrors'][field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];

        for (const key in control.errors) {
          this.formStatus['formErrors'][field] += messages[key] + ' ';
          this.errorCount++;
        }

      }
    }
  }

  getOptinDate() {
    let currentDate = new Date();
    let optinDate = moment(currentDate).format('DD/MM/YYYY hh:mm:ss')
    
    return optinDate;
  }

  formatDob(dob) {
    let dateObj = new Date(dob);
    let newDob = moment(dateObj).format('DD/MM/YYYY');

    return newDob;
  }

  submitLead() {
    if (this.budgetInsuranceForm.status !== 'VALID') {
      this.formStatus.submitClicked = true;
      this.formIsValid();
      return;
    }

    let name = this.budgetInsuranceForm.controls['name'].value;
    let surname = this.budgetInsuranceForm.controls['surname'].value;
    let telephone = this.budgetInsuranceForm.controls['telephone'].value;
    let agentName = this.budgetInsuranceForm.controls['agentName'].value;
    let tnc = this.budgetInsuranceForm.get('tnc').value;
    let product = this.budgetInsuranceForm.get('product').value;
    let dob = this.budgetInsuranceForm.get('dob').value;
    let optinDate = this.getOptinDate();
    let id = this.budgetInsuranceForm.get('id').value;
    let email = this.budgetInsuranceForm.get('email').value;

    this.success = true;
    $.post(this.API_URL, {
      FirstName: name,
      LastName: surname,
      CellNumber: telephone,
      Dob: dob,
      AcceptTerms: tnc,
      SID: this.S_ID,
      Offer_Id: this.OFFER_ID,
      optInDate: optinDate,
      AffiliateShortCode: this.AFFILIATE_SHORT_CODE,
      Product: product,
      Id: id,
      Email: email,
      LeadSource: this.LEAD_SOURCE,
      Channel: this.CHANNEL
    }, (response, status) => {
      let resp = JSON.parse(response);
      console.log(resp);
      console.log(status);

      if (status === "success") {
        console.log('success', status)
        this.success = true;
        this.googleApiIntegrationService.writeToFVSheetFuneral({
          firstName: name,
          surname: surname,
          phone: telephone,
          product: product,
          agentName: agentName.label,
          status: resp.response,
          reason: resp.leadId + "",
          dob: dob,
          optinDate: this.getOptinDate(),
          id: id,
          email: email
        });
      } else {
        let resp = JSON.parse(response);
        console.log(resp);
        console.log('error');
        if (status === "error") {
          if (!resp.leadId) {
            resp.leadId = "error";
          }
          this.googleApiIntegrationService.writeToFVSheetFuneral({
            firstName: name,
            surname: surname,
            phone: telephone,
            product: product,
            agentName: agentName.label,
            status: resp.response,
            reason: resp.leadId + "",
            dob: dob,
            optinDate: this.getOptinDate(),
            id: id,
            email: email
          });
        }
      }
    }, "json");
  }

  resetForm() {
    this.budgetInsuranceForm.reset();
    this.success = false;
  }

}
